import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const centrosCustoRepository = createRepository({
  path: 'centrosCusto',
  restApi,
  queryTransform: {
    descricao: query.ilike('descricao'),
    ...paginate
  }
})

centrosCustoRepository.sync = () => {
  return restApi.get(`centrosCusto/sync`)
}

export default centrosCustoRepository
